// Shared design tokens for the chord-practice organism.
// Kept colocated rather than promoted to a global theme, these values
// are tightly coupled to the chord-practice "premium violet" look.

export const VIOLET = "#8b5cf6";
export const VIOLET_BRIGHT = "#c4b5fd";
export const VIOLET_SOFT = "rgba(139, 92, 246, 0.12)";
export const VIOLET_GLOW = "rgba(139, 92, 246, 0.35)";
export const GOLD = "#fbbf24";
export const GREEN = "#34d399";
export const RED = "#f87171";

export const TEXT = "rgba(255, 255, 255, 0.92)";
export const TEXT_DIM = "rgba(255, 255, 255, 0.55)";
export const TEXT_MUTE = "rgba(255, 255, 255, 0.32)";
export const BORDER = "rgba(255, 255, 255, 0.06)";
export const BORDER_HI = "rgba(255, 255, 255, 0.12)";
export const SURFACE = "rgba(255, 255, 255, 0.04)";
export const SURFACE_LO = "rgba(255, 255, 255, 0.02)";

export const FONT_MONO =
  "var(--font-mono), 'JetBrains Mono', ui-monospace, monospace";
